import { render, staticRenderFns } from "./MultiUpdateProducts.vue?vue&type=template&id=9c1207ce&"
import script from "./MultiUpdateProducts.vue?vue&type=script&lang=js&"
export * from "./MultiUpdateProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports